import * as React from "react";
import styled from "styled-components";
import { VerticalSpacer } from "../Spacers";
import { theme } from "../../../theme";
import BodySmall from "../typography/BodySmall";
import SmallLoadingSpinner from "../SmallLoadingSpinner";

interface Props {
  onClick: (e?: any) => void;
  title: string;
  color?: string;
  icon?: React.ReactNode;
  iconPosition?: "left" | "right";
  loading?: boolean;
  disabled?: boolean;
  as?: React.ElementType;
}

const Container = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  font-size: 14px;
  color: ${theme.colors.text};
  background-color: transparent;
  cursor: pointer;
  padding: 8px 0px;
  width: fit-content;

  &:hover {
    filter: opacity(0.6);
  }

  &:disabled {
    cursor: default;
    opacity: 0.4;
    filter: none;
  }
`;

const TextButton: React.FC<Props> = ({
  onClick,
  title,
  color = theme.colors.text,
  icon,
  iconPosition = "left",
  loading,
  disabled,
  as,
}) => {
  return (
    <Container onClick={onClick} disabled={disabled} as={as}>
      {icon && iconPosition === "left" && (
        <>
          {icon}
          <VerticalSpacer spacing={0.5} />
        </>
      )}
      {loading ? (
        <SmallLoadingSpinner />
      ) : (
        <BodySmall color={color}>{title}</BodySmall>
      )}
      {icon && iconPosition === "right" && (
        <>
          <VerticalSpacer spacing={0.5} />
          {icon}
        </>
      )}
    </Container>
  );
};

export default TextButton;
